import { Box, Card } from '@mui/material'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)
import WTypography from '../../../../Components/whiteTypography'
import { isEmpty } from 'lodash'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight'

function Recommandation({ oldData, updateReports }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const [open, setOpen] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {}, [])
  useEffect(() => {}, [oldData])

  return (
    <Card className="dashboard_card__root1">
      <Box className="dashboard_card__header1">
        <WTypography component={'span'} variant="h6">
          {t('professionnelle.recommandation') /* LAP-733 (GE022) */}
        </WTypography>
      </Box>

      <Box mt={7} minWidth={3} mb={6} height={'100%'}>
        {isEmpty(oldData) ? (
          <Box
            className="no-drag"
            height={'70%'}
            justifyContent={'center'}
            color={'white'}
            display={'flex'}
            flexDirection={'column'}
            alignItems={'center'}
          >
            <Box padding={'0 20px'} textAlign={'center'} fontWeight={'800'}>
              {t('professionnelle.recommandationDesc') /* LAP-733 (GE022) */}
            </Box>
            <Box padding={'0 20px'} display={'flex'} width={'100%'} justifyContent={'end'} mt={5}>
              {t('professionnelle.openAi') /* LAP-733 (GE022) */}
            </Box>
          </Box>
        ) : (
          <>
            <Box
              height={'50%'}
              justifyContent={'center'}
              color={'white'}
              display={'flex'}
              flexDirection={'column'}
              fontSize={'20px'}
            >
              <Box textAlign={'center'} fontStyle={'italic'}>
                {oldData?.content}
              </Box>
              <Box textAlign={'right'} mt={5}>
                {oldData?.source}
              </Box>
            </Box>
            {oldData?.function && (
              <Box color={'white'} textAlign={'center'} mt={8} className="no-drag">
                {oldData?.function}
                <Box
                  sx={{ cursor: 'pointer' }}
                  component={'span'}
                  ml={2}
                  onClick={() => navigate(oldData.function_link)}
                >
                  <KeyboardArrowRightIcon sx={{ bgcolor: '#438295', borderRadius: '50%' }} />
                </Box>
              </Box>
            )}
          </>
        )}
      </Box>
    </Card>
  )
}

export default Recommandation
